import {
  landingServiceManaged,
  landingServiceSelfServe,
  landingServiceVerification,
  landingStepMeasure,
  landingStepPayout,
  landingStepPublish,
  landingStepSource,
  landingStepStrategy,
  landingStepVerify,
} from "@/lib/assets";

/** Copy shared by the desktop and mobile landing layouts. */
export const clippingSteps = [
  {
    title: "Strategy",
    icon: landingStepStrategy,
    description: "Create the brief, provide assets and Evangelist fills content gaps with UGC.",
  },
  { title: "Source", icon: landingStepSource, description: "Access 500,000+ creators via the Evangelist platform." },
  {
    title: "Publish",
    icon: landingStepPublish,
    description: "Clippers publish approved content. Social algorithms determine distribution.",
  },
  {
    title: "Verify",
    icon: landingStepVerify,
    description:
      "Every frame, description, engagement, and audio file analyzed. Bots, fraud and brand guideline violations identified with automated response.",
  },
  // Payout precedes Measure: the design lays these out as a 3x2 grid and Payout sits in the
  // second row's middle cell.
  {
    title: "Payout",
    icon: landingStepPayout,
    description:
      "Verified views are paid out up to campaign brief. Over-delivery results in earned media further driving down eCPMs.",
  },
  {
    title: "Measure",
    icon: landingStepMeasure,
    description:
      "Clipping provides more than just reach. Evangelist helps you unlock the insights and business impact that every campaign delivers.",
  },
] as const;

export const serviceOptions = [
  {
    title: "Self-service platform",
    icon: landingServiceSelfServe,
    description:
      "Plan and buy campaigns, monitor performance, and manage billing through the Evangelist self-serve platform. Fraud and brand-safety controls and detection included.",
  },
  {
    title: "Platform + managed services",
    icon: landingServiceManaged,
    description:
      "Get the platform plus hands-on support with content strategy, campaign planning, execution and advanced measurement.",
  },
  {
    title: "Verification & fraud protection",
    icon: landingServiceVerification,
    description:
      "Add bot detection and view verification to campaigns running across integrated clipping marketplaces.",
  },
] as const;
